export default __webpack_public_path__ + "static/media/grey-badge-icon.41ed9411.svg";